import React from 'react';
import T from 'i18n-react';
import Plans from '../Plans';
import { API_V1_FAVORITE_PLANS } from '../../routing';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { UsersitePlansGetManyPlansTypePayload } from '~/models/schema';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: theme.typography.pxToRem(24),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(32),
    },
  },
}));

type Props = {
  plans: Array<UsersitePlansGetManyPlansTypePayload>;
  acceptingPlans: Array<UsersitePlansGetManyPlansTypePayload>;
  count: number;
};

const FavoriteIndex = ({
  plans = [],
  acceptingPlans = [],
  count = 0,
}: Props) => {
  const classes = useStyles();

  return (
    <Plans
      plans={plans}
      acceptingPlans={acceptingPlans}
      count={count}
      isAuthenticated
      title={T.translate('menu.favorite') as string}
      apiPath={API_V1_FAVORITE_PLANS}
      classes={{ title: classes.title }}
    />
  );
};

export default FavoriteIndex;
